import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import {
  FaBuilding, FaUserFriends, FaCalendarAlt, FaFileInvoiceDollar, FaFileExport, FaLandmark,
  FaSignOutAlt, FaGraduationCap, FaTachometerAlt, FaChevronLeft, FaChevronRight, FaTimes,
} from 'react-icons/fa';
import './Sidebar.css';

const Sidebar = ({ selectedOrg, userRole, collapsed, onToggle, mobileOpen, onMobileClose }) => {
  const { instance, accounts } = useMsal();
  const location = useLocation();
  const navigate = useNavigate();

  const navItems = [
    { to: '/dashboard', label: 'Dashboard', icon: <FaTachometerAlt size={16} /> },
    { to: '/employees', label: 'Employees', icon: <FaUserFriends size={16} /> },
    { to: '/payroll-periods', label: 'Pay Schedules', icon: <FaCalendarAlt size={16} /> },
    { to: '/payroll-records', label: 'Payroll Records', icon: <FaFileInvoiceDollar size={16} /> },
    { to: '/payroll-reports', label: 'Reporting & Compliance', icon: <FaLandmark size={16} /> },
  ];

  if (userRole !== 'l1' && userRole !== 'l2') {
    navItems.push({ to: '/bulk-export', label: 'Bulk Export', icon: <FaFileExport size={16} /> });
  }

  if (selectedOrg && selectedOrg.industry === 'College/School') {
    navItems.push({ to: '/students', label: 'Student Database', icon: <FaGraduationCap size={16} /> });
  }

  const getInitials = (name) => (name ? name.substring(0, 2).toUpperCase() : 'OR');
  const displayUserName = accounts.length > 0 ? accounts[0].name : 'User';
  const orgName = selectedOrg ? selectedOrg.name : 'No Org Selected';

  const handleLogout = () => {
    instance.logoutRedirect({ postLogoutRedirectUri: window.location.origin });
  };

  return (
    <>
      {mobileOpen && <div className="op-sidebar-backdrop" onClick={onMobileClose} />}
      <aside className={`op-sidebar ${collapsed && !mobileOpen ? 'collapsed' : ''} ${mobileOpen ? 'mobile-open' : ''}`}>
      <button
        className="op-toggle-btn"
        onClick={onToggle}
        title={collapsed ? 'Expand menu' : 'Collapse menu'}
        aria-label={collapsed ? 'Expand menu' : 'Collapse menu'}
      >
        {collapsed ? <FaChevronRight size={10} /> : <FaChevronLeft size={10} />}
      </button>
      <button
        className="op-mobile-close-btn"
        onClick={onMobileClose}
        aria-label="Close menu"
      >
        <FaTimes size={13} />
      </button>

      <div className="op-sidebar-scroll">
     <div className="header-left" style={{ zIndex: 2 }}>
  <Link to="/org-management" className="text-decoration-none flex-shrink-0">
    <div className="op-sidebar-logo-wrap">
      {collapsed && !mobileOpen ? (
        <img
          src="/favicon.png"
          alt="OrientalPay"
          style={{ height: '34px', width: '34px', objectFit: 'contain' }}
        />
      ) : (
        <img
          src="/op_logo.png"
          alt="OrientalPay"
          style={{ height: '42px', objectFit: 'contain' }}
        />
      )}
    </div>
  </Link>
</div>

      <nav className="op-sidebar-nav">
        {navItems.map((item) => (
          <Link
            key={item.to}
            to={item.to}
            title={collapsed ? item.label : undefined}
            onClick={onMobileClose}
            className={`op-sidebar-link ${location.pathname === item.to ? 'active' : ''}`}
          >
            {item.icon}
            <span className="op-label">{item.label}</span>
          </Link>
        ))}
      </nav>

      <div className="op-sidebar-footer">
        <div className="op-sidebar-card">
          <div className="op-sidebar-user">
            <div className="op-sidebar-avatar">{getInitials(displayUserName)}</div>
            <div>
              <div className="op-sidebar-username">{displayUserName}</div>
              <div className="op-sidebar-orgname">{orgName}</div>
            </div>
          </div>
          {userRole !== 'l1' && userRole !== 'l2' && (
            <button
              className="op-sidebar-card-link"
              onClick={() => { navigate('/org-management'); if (onMobileClose) onMobileClose(); }}
              title={collapsed ? 'Org Management' : undefined}
            >
              <FaBuilding size={15} /> <span className="op-label">Org Management</span>
            </button>
          )}
          <button
            className="op-sidebar-card-link danger"
            onClick={handleLogout}
            title={collapsed ? 'Sign Out' : undefined}
          >
            <FaSignOutAlt size={15} /> <span className="op-label">Sign Out</span>
          </button>
        </div>
      </div>
      </div>
    </aside>
    </>
  );
};

export default Sidebar;